exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#header #body[data-v-15244339],#header #bottom[data-v-15244339]{padding:24px}", ""]);

// exports
